import { cookieNames } from "../config";
import { initialiseTrackingScripts } from "./tracking";

/** Cookies **/

const cookieNotice = document.getElementById("gdpr-banner");
const acceptButton = document.getElementById("gdpr-banner-accept-button");
const dismissButton = document.getElementById("gdpr-banner-reject-button");
const updateForm = document.getElementById("gdpr-form");
const updateCheckbox = document.getElementById("gdpr-form__checkbox");

/**
 * title Set Cookies
 * description Set certain cookies based on name & value with a expiration date
 * @param {string} name
 * @param {string} value
 * @param {int} expire
 */

function setCookie(name, value, expireDays) {
	const date = new Date();

	// Get the date based on the expire days
	date.setTime(date.getTime() + expireDays * 24 * 60 * 60 * 1000);
	const expires = "expires=" + date.toUTCString();

	// Set the Cookie
	document.cookie = name + "=" + value + ";" + expires + ";path=/";
}

/**
 * title Delete all Cookies
 * description Deletes all cookies which do not have the HttpOnly Flag. The flag disables Javascript's access to the code.
 */

function deleteAllCookies() {
	let cookies = document.cookie.split("; ");

	for (const cookie of cookies) {
		// We want to the get the cookie by name and set the expiry in the past so that the cookie is removed
		const cookieIndex = cookie.indexOf("=");

		const name = cookieIndex > -1 ? cookie.substr(0, cookieIndex) : cookie;

		// Set the cookie with the new expiry date
		document.cookie = name + "=null;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/";
	}
}

/**
 * title Accept Cookies
 * description Accept Cookies and add them to browser
 * @param {bool} reload - Whether or not to reload the browser session
 */

function acceptCookies(reload) {
	// We want to set the cookie with a 1 year expiry date
	setCookie(cookieNames.cookiesAccepted, "true;secure", 365);

	// Add a local storage option that we can check against during initiation
	localStorage.setItem("cookies", "true");

	// If the cookie notice exists on the page, we want to hide it
	if (cookieNotice) {
		cookieNotice.classList.add("hidden");
	}

	initialiseTrackingScripts();

	// If reload is true we want to refresh the page
	// if (reload) {
	// 	window.location.reload();
	// }
}

/**
 * title Reject Cookies
 * description Reject Cookies and remove them from the browser
 * @param {bool} reload - Whether or not to reload the browser session
 */
function rejectCookies(reload) {
	// Remove all cookies
	deleteAllCookies();

	setCookie(cookieNames.cookiesAccepted, "false;secure", 365);

	// Add a local storage option that we can check against during initiation
	localStorage.setItem("cookies", "false");

	// If the cookie notice exists on the page, we want to hide it
	if (cookieNotice) {
		cookieNotice.classList.add("hidden");
	}

	// If reload is true we want to refresh the page
	if (reload) {
		window.location.reload();
	}
}

/**
 * title Initiate Cookies
 * description Initiate the Cookie Notice if local storage says they are not set
 * return bool/null
 */
function initiateCookies() {
	// Get local storage item to see if cookies have been accepted/rejected
	const cookieStorage = localStorage.getItem("cookies");

	if (cookieStorage === "false") {
		rejectCookies();
	} else if (cookieStorage === "true") {
		acceptCookies();
	}

	return;
}

// If the accept button is found, accept cookies on click
if (acceptButton) {
	acceptButton.addEventListener("click", function (e) {
		e.preventDefault;
		acceptCookies(true);
	});
}

// If the dismiss button is found, reject cookies on click
if (dismissButton) {
	dismissButton.addEventListener("click", function (e) {
		e.preventDefault;
		rejectCookies(false);
	});
}

// If the update cookies form is found && the checkbox exists, change cookie preferences based on the checkbox value
if (updateForm && updateCheckbox) {
	updateCheckbox.addEventListener("change", function (e) {
		if (!this.checked) {
			rejectCookies();
		} else {
			acceptCookies();
		}
	});
}

export default initiateCookies;
